module.exports = __webpack_public_path__ + "media/images/front/responsive/clinic_top_page/338628/target02-7092057698b8bcb9ee89c941a84e1238.png";